import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { GlobalTheme } from '../../theme';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DisplayQuillContent from '../../components/DisplayQuillContent';
import Tooltip from '@mui/material/Tooltip';
const API_URL = 'https://aaryanholidays.in/frontend/testimonials';
const AVATAR_PREFIX = 'https://aaryanholidays.in/express/uploads/';


const labels: { [index: string]: string } = {
    0.5: 'Useless',
    1: 'Useless+',
    1.5: 'Poor',
    2: 'Poor+',
    2.5: 'Ok',
    3: 'Ok+',
    3.5: 'Good',
    4: 'Good+',
    4.5: 'Excellent',
    5: 'Excellent+',
};

export default function App() {
    const [testimonials, setTestimonials] = useState([]);
    const value = 3.5;

    useEffect(() => {
        fetch(API_URL)
            .then(response => response.json())
            .then(data => {
                // Update testimonials with full avatar URLs
                const updatedTestimonials = data.map(item => ({
                    ...item,
                    avatar: `${AVATAR_PREFIX}${item.image_avatar}`
                }));
                setTestimonials(updatedTestimonials);
            })
            .catch(error => console.error('Error fetching testimonials:', error));
    }, []);
   function getTrimmedContent(html, wordLimit) {
    //if (!html) return { trimmedHtml: "", isTrimmed: false };

    // Remove HTML tags for counting words
    const textOnly = html.replace(/<[^>]+>/g, ' ').trim();
    const words = textOnly.split(/\s+/);
//alert(words.length);
    if (words.length <= wordLimit) {
        return { trimmedHtml: html, isTrimmed: false };
    }

    const trimmedText = words.slice(0, wordLimit).join(" ") + " ...";

    return {
        trimmedHtml: trimmedText,  // trimmed text ONLY
        isTrimmed: true
    };
}

    return (
        <>
            <Swiper
                spaceBetween={30}
                pagination={{
                    clickable: true,
                }}
                modules={[Pagination, Autoplay]}
                style={{ paddingBottom: '40px', paddingLeft: '10px', paddingRight: '10px' }}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: true,
                }}
                breakpoints={{
                    0: {
                        slidesPerView: 1,
                    },
                    600: {
                        slidesPerView: 2,

                    },
                    1536: {
                        slidesPerView: 3,
                    },
                }}
            >
                {testimonials.map((testimonial) => (
                    <SwiperSlide key={testimonial.id}>
                        <Card sx={{
                            mx: 'auto', my: 2, p: 2, borderRadius: 2,
                            textAlign: 'center', height: 300,
                            display: 'flex', flexDirection: 'column'
                        }} elevation={4}>

                            {/* <CardHeader
                                    sx={{
                                        flexWrap: {
                                            md: 'wrap'
                                        },
                                        flexDirection: {
                                            xs: 'column',
                                            md: 'row'
                                        },
                                        textAlign: 'center',
                                        alignContent: 'start',
                                        justifyContent: 'center',
                                        "& .MuiCardHeader-title": {
                                            fontSize: '1rem'
                                        }
                                    }}
                                // avatar={
                                //     <Avatar
                                //         sx={{ bgcolor: GlobalTheme.palette.secondary.main, width: 163, height: 163, mb: 2 }}
                                //         aria-label=""
                                //         src={testimonial.avatar}
                                //     >
                                //         {!testimonial.avatar.startsWith('http') && testimonial.avatar}
                                //     </Avatar>
                                // }
                                /> */}
                            <CardContent>

                                <Typography gutterBottom variant="subtitle1" component="p" align="left">
                                    <DisplayQuillContent content={testimonial.heading || 'No Title'} />

                                </Typography>
                                <Typography variant="body2" color="text.secondary" align="left">
                                    <Typography variant="body2" color="text.secondary" align="left">
                                        <Tooltip
                                            title={
                                                <Box sx={{ p: 1 }}>
                                                    <DisplayQuillContent content={testimonial.description || 'No Description'} />
                                                </Box>
                                            }
                                            placement="top"
                                            arrow
                                        >
                                            <Box sx={{ cursor: "pointer" }}>
                                                <DisplayQuillContent
                                                    content={getTrimmedContent(
                                                        testimonial.description || "No Title",
                                                        17
                                                    ).trimmedHtml}
                                                />
                                            </Box>
                                        </Tooltip>
                                    </Typography>

                                </Typography>
                                <Typography variant="body2" color="text.secondary" align="left" mt={2} sx={{ fontWeight: 'bold' }}>

                                    <DisplayQuillContent content={testimonial.title || 'No Title'} />
                                </Typography>
                                <Typography variant="body2" color="text.secondary" align="left"   >
                                    <DisplayQuillContent content={testimonial.subheader || 'No Title'} />

                                </Typography>

                                <Box sx={{ width: 200, display: 'flex', alignItems: 'center', mt: 2 }}>
                                    <Rating
                                        name="text-feedback"
                                        value={testimonial.text_start_rating}
                                        readOnly
                                        precision={0.5}
                                        emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                                    />
                                    {/* <Box sx={{ ml: 2 }}>{labels[testimonial.text_start_rating]}</Box> */}
                                </Box>
                            </CardContent>

                        </Card>
                    </SwiperSlide>
                ))}
            </Swiper>
        </>
    );
}
